
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","stroke":"#515358"}}),_c('path',{attrs:{"fill":"#515358","d":"M29.23 10H17.86L10 17.89v11.22L17.89 37h11.25L37 29.14V17.77z"}}),_c('path',{attrs:{"d":"M26.06 28.629c0 .968-.608 1.253-1.358.637l-7.455-6.125c-.333-.274-.33-.712.01-.98l7.422-5.85c.763-.602 1.382-.304 1.382.664V28.63z","fill":"#FFF"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/closureArea.svg